import React, { useEffect, useState, useMemo } from 'react'
import { Carousel } from 'antd'
import { useStores } from '@/store'
import { getQuery } from '../../service/http'
import { useTranslation } from 'react-i18next'
import { isMobile, handleDeepLink } from '@/service/utils'
import './eventBlock.less'
const EventBlock = ({ currentEvent }) => {
  const { project, website_url, accent_color } = currentEvent
  const { t } = useTranslation()
  const { region } = getQuery()
  const { HomeStore } = useStores()
  const [logo, setLogo] = useState(null)
  const [banner, setBanner] = useState([])
  const [shortCuts, setShortCuts] = useState([])
  const [contentBlock, setContentBlock] = useState([])
  const contentCarouselRef = React.createRef()
  const shortCutsCarouselRef = React.createRef()
  useEffect(() => {
    HomeStore.getEventBlockLogo(project).then(setLogo)
    HomeStore.getBanner(project, isMobile() ? 'dc_homepage_banner_mobile' : 'dc_homepage_banner_web').then(setBanner)
    HomeStore.getShortCuts(region, project, isMobile()).then(setShortCuts)
    HomeStore.getContentBlock(region, project, isMobile()).then(res => {
      if (res.length < 3 && res.length > 0) {
        setContentBlock([res])
        return
      }
      const arr = []
      const num = Math.floor(res.length / 3)
      for (let i = 0; i < num; i++) {
        arr.push(res.slice(i * 3, (i + 1) * 3))
      }
      if (res.length % 3 !== 0 && res.length > 3) {
        arr.push(res.slice(res.length - 3, res.length))
      }
      setContentBlock(arr)
    })
  }, [])
  const swiper = useMemo(() => {
    if (shortCuts?.length) {
      let tempCuts = [...shortCuts]
      let tempSwiper = []
      const step = 10
      for (let index = 0; index < tempCuts.length; index += step) {
        tempSwiper.push(tempCuts.slice(index, index + step))
      }
      return tempSwiper
    } else {
      return []
    }
  }, [shortCuts])
  const splitIntoChunks = (arr, chunkSize = 5) => {
    const chunks = []
    for (let i = 0; i < arr.length; i += chunkSize) {
      chunks.push(arr.slice(i, i + chunkSize))
    }
    return chunks
  }
  return (
    <div className='event-block'>
      <div className='event-block-context' style={{ background: accent_color }}>
        {banner.img_url && (
          <div className='event-block-context-banner'>
            <img onClick={() => window.open(website_url, '_blank')} src={banner.img_url} alt='' />
          </div>
        )}
        {!!shortCuts.length && (
          <div className='event-block-context-shortCuts'>
            <div className='shortcuts-mobile'>
              <Carousel adaptiveHeight={true} infinite={false}>
                {swiper.map((cuts, index) => (
                  <div key={index}>
                    <div className='shortcuts-item' style={{ justifyContent: shortCuts.length < 5 ? 'center' : 'left' }}>
                      {cuts.map(item => (
                        <a
                          key={item.id}
                          href={item?.links?.web || item?.links?.ios}
                          className='shortcut'
                          onClick={(event) => {
                            event.preventDefault()
                            handleDeepLink(item?.links?.web || item?.links?.ios)
                          }}
                        >
                          <img src={item.icon_url} alt='' />
                          <div className='title'>{item.title}</div>
                        </a>
                      ))}
                    </div>
                  </div>
                ))}
              </Carousel>
            </div>
            <div className='shortcuts-pc'>
              <Carousel autoplay={false} ref={shortCutsCarouselRef} adaptiveHeight={true} dots={false}>
                {swiper.map((cuts, index) => (
                  <div key={index}>
                    <div>
                      {splitIntoChunks(cuts).map(lineItem => (
                        <div className='shortcuts-item' style={{ justifyContent: shortCuts.length < 5 ? 'center' : 'left' }}>
                          {lineItem.map(item => (
                            <a
                              key={item.id}
                              href={item?.links?.web || item?.links?.ios}
                              className='shortcut'
                              onClick={(event) => {
                                event.preventDefault()
                                handleDeepLink(item?.links?.web || item?.links?.ios)
                              }}
                            >
                              <img src={item.icon_url + '-thumb'} alt='' />
                              <div className='title'>{item.title}</div>
                            </a>
                          ))}
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </Carousel>
              {swiper.length > 1 && (
                <div className='tigger'>
                  <div className='prev' onClick={() => shortCutsCarouselRef.current.prev()}>
                    <i className='icon icon-arrow-left'></i>
                  </div>
                  <div className='next' onClick={() => shortCutsCarouselRef.current.next()}>
                    <i className='icon icon-arrow-right'></i>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
        {!!contentBlock.length && (
          <div className='event-block-context-content'>
            <div className='event-block-banners'>
              <Carousel autoplay ref={contentCarouselRef}>
                {contentBlock.map(arr => (
                  <div style={{ display: 'flex', justifyContent: 'left' }}>
                    {arr.map(item => (
                      <div
                        key={item.id}
                        className='banner-item'
                        onClick={() => {
                          handleDeepLink(item.link)
                        }}
                      >
                        <img src={item.image_url} alt='' />
                      </div>
                    ))}
                  </div>
                ))}
              </Carousel>
              <div className='tigger'>
                <div onClick={() => contentCarouselRef.current.prev()}></div>
                <div onClick={() => contentCarouselRef.current.next()}></div>
              </div>
            </div>
          </div>
        )}
        <div className='event-block-context-logo'>
          <img src={logo?.img_url} alt='' onClick={() => window.open(website_url, '_blank')} />
        </div>
      </div>
      <div className='event-block-text'>{t('WEB.Also on DiningCity')}</div>
    </div>
  )
}

export default EventBlock
